import React, {Component} from 'react';
import {observer} from "mobx-react";
import objectPath from "object-path";
import File from "./File";

class MultiStr extends Component {
  getValue(item) {
    if(this.props.field && this.props.field.view_options && this.props.field.view_options.view_code) {
      return objectPath.get(item, this.props.field.view_options.view_code);
    }
    return "—";
  }
  getExtension(item) {
    const ex=item.real.split(".");
    if(ex.length>1) {
      return ex[ex.length-1];
    }
    return "";
  }
  getFileName(item) {
    const ex=item.real.split("/");
    return ex[ex.length-1];
  }
  render() {
    if(this.props.value && Array.isArray(this.props.value)) {
      const multiReturn=this.props.value.map((item, index)=>{
        const val=this.getValue(item);
        let preview;
        if(val.evapreview) {
          preview=(
            <img src={val.evapreview} style={{width:50, height:50, objectFit:"contain"}} className="db bg-w2"/>
          );
        } else {
          preview=(
            <div style={{width:50,height:50}} className="bg-w2 pr">
              <div className="pa pa-bl w100 pbottom5 tac bold ttu fs12">{this.getExtension(val)}</div>
            </div>
          );
        }
        return (
          <div key={index} className="up12 splice mbottom5 s-nowrap pr">
            <div className="cell s-shrink">{preview}</div>
            <div className="cell s-shrink s-middle pleft5 fs11" style={{width:100, wordBreak:'break-word'}}>
              {this.getFileName(val)}
            </div>
            <a href={val.real} target="_blank" rel="noreferrer noopener nofollow" className="pa pa-tl w100 h100"></a>
          </div>
        )
      });

      return multiReturn;
    }

    return null;
  }
}

export default observer(MultiStr);